import React from 'react'
import moment from 'moment'
import util from '../util'
const humanizeFilesize = util.humanizeFilesize

function getDimensions (asset) {
    if (asset.type === 'image') return (asset.advancedDetails.image[0].width +
        ' × ' + asset.advancedDetails.image[0].height)

    if (asset.type === 'video') {
        var dimensions = asset.advancedDetails.video[0].dimensions
        return (dimensions.width + ' × ' + dimensions.height)
    }
}

const AssetInfoTable = props => {
    const { asset } = props
    var now = moment()
    var assetTTL = moment(asset.TTL)
    var ttl = asset.TTL ?
        moment(assetTTL.diff(now)).format('D HH:mm:ss').split(' ') :
        null

    if (ttl) {
        ttl[0] += ' days,'
        ttl = ttl.join(' ')
    }
    ttl = ttl || <em>Not available</em>

    var filename
    try {
        filename = asset.advancedDetails.general.filename
    } catch (err) {
        filename = <em>Not available</em>
    }

    var dimensions
    try {
        dimensions = getDimensions(asset)
    } catch (err) {
        // ok
    }

    var aspectRatio
    try {
        aspectRatio = asset.advancedDetails.video[0].aspect_ratio
    } catch (err) {
        // ok
    }
    
    return <table className="table table-bordered table-striped table-condensed">
        <tbody>
            <tr>
                <td><strong>Asset ID</strong></td>
                <td><span className="format-monospace">{asset.assetID}</span></td>
            </tr>
            <tr>
                <td><strong>Status</strong></td>
                <td>{asset.currentStatus}</td>
            </tr>
            <tr>
                <td><strong>Media Type</strong></td>
                <td>{asset.type}</td>
            </tr>
            <tr>
                <td><strong>Size</strong></td>
                <td>{asset.fileSize !== 0 ?
                    humanizeFilesize(asset.fileSize) :
                    'Could not calculate'
                }</td>
            </tr>
            <tr>
                <td><strong>Shelf Life</strong></td>
                <td>{ttl}</td>
            </tr>
            <tr>
                <td><strong>Date Created</strong></td>
                <td>{asset.dateCreated}</td>
            </tr>

            <tr>
                <td><strong>Original filename</strong></td>
                <td>{filename}</td>
            </tr>

            {dimensions ?
                <tr>
                    <td><strong>Dimensions</strong></td>
                    <td>{dimensions}</td>
                </tr> :
                null
            }

            {aspectRatio ?
                <tr>
                    <td><strong>Aspect ratio</strong></td>
                    <td>{aspectRatio}</td>
                </tr> :
                null
            }
        </tbody>
    </table>
}

export default AssetInfoTable
